/**
 * A drop's "who gets it" cell (19/10/2026 — one column instead of two, so
 * the list fits without sliding sideways): per group of the drop, one line —
 * its chip (opens the group picker), then the list(s) this very drop goes
 * to (opens the list picker). No group yet: a "Choose group" and a list-first picker.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DayPlanGroupRow } from '@trafficpulse/shared';

import type { DayPlanDropRow, DraftSlot } from '../../../../../drop-generator.types';
import type { GroupRef } from '../../hooks/use-general-times';
import type { SlotPatch } from '../../../state/slots/slot-ops';
import { DropGroups } from './DropGroups';
import { SlotListPin } from './SlotListPin';

export const DropLists: FC<{
  slot: DraftSlot;
  position: number;
  groupRefs: GroupRef[];
  defaultAmount: number;
  planned: DayPlanDropRow[];
  planGroups: DayPlanGroupRow[];
  onPatch: (patch: SlotPatch) => void;
}> = ({ slot, position, groupRefs, defaultAmount, planned, planGroups, onPatch }) => {
  const selected = groupRefs.filter((group) => slot.listGroupIds.includes(group.id));
  const picker = { slot, position, groupRefs, defaultAmount, onPatch };
  if (!selected.length)
    return (
      <div className="flex min-w-0 items-center gap-1.5">
        <DropGroups {...picker} />
        <SlotListPin groups={groupRefs} slot={slot} position={position} onPatch={onPatch} />
      </div>
    );
  return (
    <div className="flex min-w-0 flex-col gap-0.5">
      {selected.map((group) => (
        <div key={group.id} className="flex min-w-0 items-center gap-1.5">
          <span className="max-w-[42%] shrink-0">
            <DropGroups {...picker} only={group} />
          </span>
          <SlotListPin
            group={group}
            groups={[group]}
            slot={slot}
            position={position}
            planned={planned}
            planGroup={planGroups.find((g) => g.listGroupId === group.id)}
            onPatch={onPatch}
          />
        </div>
      ))}
    </div>
  );
};
